import { Component, EventEmitter, Input, Output } from "@angular/core";
import { PatientBenefitActionEvent, PatientBenefits } from "../models";

@Component({
  selector: "patient-benefits-table",
  templateUrl: "patient-benefits-table.html",
})
export class PatientBenefitsTableComponent {
  @Input() activePatientBenefitsList: PatientBenefits[];
  @Input() expiredPatientBenefitsList: PatientBenefits[];
  @Input() responseMsg: string = "No benefits found.";
  @Input() canEdit: boolean;
  @Output() editPatientBenefitEvent =
    new EventEmitter<PatientBenefitActionEvent>();

  constructor() {}

  editPatientBenefit(event: PatientBenefitActionEvent) {
    this.editPatientBenefitEvent.emit(event);
  }

  validateBenefitLists() {
    return (
      this.activePatientBenefitsList.length ||
      this.expiredPatientBenefitsList.length
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/patient-chart/patient-benefits/patient-benefits-table/patient-benefits-table.ts